let hashParameters: Record<string, string | string[]>;

parseHashParams();

function parseHashParams() {
	hashParameters = {};

	const params = new URLSearchParams(window.location.hash.slice(1));

	for (const [key, value] of params) {
		if (hashParameters[key]) {
			const currentParams = hashParameters[key];

			hashParameters[key] = Array.isArray(currentParams) ? [...currentParams, value] : [currentParams, value];
		} else {
			hashParameters[key] = value;
		}
	}
}

function getParameter(key: string): string | string[] | undefined {
	return hashParameters[key];
}

function addHashParamsListener(hashParam: string, handler: () => void) {
	window.addEventListener('hashchange', () => {
		parseHashParams();

		if (getParameter(hashParam) !== undefined) {
			handler();
		}
	});
}

export default {
	'get': getParameter,
	'addListener': addHashParamsListener
};